import { render, staticRenderFns } from "./Activities.vue?vue&type=template&id=bc20dc56&scoped=true"
import script from "./Activities.vue?vue&type=script&lang=js"
export * from "./Activities.vue?vue&type=script&lang=js"
import style0 from "./Activities.vue?vue&type=style&index=0&id=bc20dc56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc20dc56",
  null
  
)

export default component.exports